import { render, staticRenderFns } from "./assessmentDialog.vue?vue&type=template&id=04a82333&scoped=true"
import script from "./assessmentDialog.vue?vue&type=script&lang=js"
export * from "./assessmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a82333",
  null
  
)

export default component.exports